const logCashPaymentModel = {
    formId: 'logCashPaymentForm',
    formField: {
        client: {
            name: 'client',
            label: 'Client',
            required: true,
            requiredErrorMsg: 'A client is required',
            invalidErrorMsg: 'Invalid client'
        },
        property: {
            name: 'property',
            label: 'Property',
            required: true,
            requiredErrorMsg: 'A property is required',
            invalidErrorMsg: 'Invalid property'
        },

        amount: {
            name: 'amount',
            label: 'Payment Amount',
            required: true,
            requiredErrorMsg: 'An amount is required',
            invalidErrorMsg: 'Invalid amount'
        },

        receiptNumber: {
            name: 'receiptNumber',
            label: 'Receipt Number',
            required: true,
            requiredErrorMsg: 'A receipt number is required',
            invalidErrorMsg: 'Invalid receipt number'
        },

        purpose: {
            name: 'purpose',
            label: 'Purpose',
            required: true,
            requiredErrorMsg: 'A purpose is required',
            invalidErrorMsg: 'Invalid purpose'
        },
        internetPackageId: {
            name: 'internetPackageId',
            label: 'Internet Package',
            requiredErrorMsg: 'An internet package is required',
            invalidErrorMsg: 'Invalid internet package'
        },

        paymentMethod: {
            name: 'paymentMethod',
            label: 'Payment Method',
            required: true,
            requiredErrorMsg: 'A payment method is required',
            invalidErrorMsg: 'Invalid payment method'
        },
        paymentDate: {
            name: 'paymentDate',
            label: 'Payment Date',
            required: true,
            requiredErrorMsg: 'A payment date is required',
            invalidErrorMsg: 'Invalid payment date'
        },
    },
    initialValues: {
        client: "",
        property: "",
        amount: null,
        receiptNumber: "",
        purpose: "",
        internetPackageId: "",
        paymentMethod: "Cash",
        paymentDate: new Date().toISOString().split("T")[0],
    }
};

export type logCashPaymentModelType = {
    client: string,
    property: string,
    amount: number | null,
    receiptNumber: string,
    purpose: string,
    internetPackageId: string,
    paymentMethod: string,
    paymentDate: string,
}

export default logCashPaymentModel
  